'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002epackage$0024package$0024$002dPassword$0024 from "./samples.package$package$-Password$.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$3() {
}
export { $c_Lsamples_Persons$package$$anon$3 as $c_Lsamples_Persons$package$$anon$3 };
$p = $c_Lsamples_Persons$package$$anon$3.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$3;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$3() {
}
export { $h_Lsamples_Persons$package$$anon$3 as $h_Lsamples_Persons$package$$anon$3 };
$h_Lsamples_Persons$package$$anon$3.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return $j_samples$002epackage$0024package$0024$002dPassword$0024.$m_Lsamples_package$package$Password$().Pb();
});
var $d_Lsamples_Persons$package$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$3, "samples.Persons$package$$anon$3", ({
  pL: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$3 as $d_Lsamples_Persons$package$$anon$3 };
